import injected from '../injected';

export var makeTooltipText = function makeTooltipText(reactions) {
  if (!reactions || reactions.length < 1) {
    return '';
  }
  var names = reactions.map(function (r) {
    return r.from.userId === injected.user.id ? 'You' : r.from.displayName;
  });
  var text = 'From ';
  for (var i = 0, l = names.length; i < l; i++) {
    if (i === 0) {
      text += names[i];
    } else if (i === names.length - 1) {
      text += ' and ' + names[i];
    } else {
      text += ', ' + names[i];
    }
  }
  return text;
};
//# sourceMappingURL=reactions.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-misc/lib/utils/reactions.js
// module id = 773
// module chunks = 0